export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 2_09.2f627884.jpg";